// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"20":"records-index","57":"index","580":"records-id-index","963":"upload-index"}[chunkId] + "." + {"20":"5afa6898","57":"e99ca8eb","580":"619d8b1a","963":"b6e892af"}[chunkId] + ".js";
};